import React from 'react';
import CargaMasivaGenerico from './CargaMasivaGenerico';

const ModalCargaMasiva = ({ 
  isOpen, 
  onClose, 
  title, 
  subtitle, 
  config, 
  onDataLoaded 
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        width: '95%',
        maxWidth: '1400px',
        maxHeight: '90vh',
        overflow: 'auto',
        position: 'relative',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
      }}>
        <div style={{
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          borderBottom: '1px solid #e5e7eb',
          padding: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '12px 12px 0 0'
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
              {title}
            </h2>
            <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
              {subtitle}
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '36px',
              cursor: 'pointer',
              color: '#9ca3af',
              padding: '12px',
              borderRadius: '8px',
              transition: 'all 0.2s',
              minWidth: '48px',
              minHeight: '48px'
            }}
            onMouseOver={(e) => e.target.style.color = '#4b5563'}
            onMouseOut={(e) => e.target.style.color = '#9ca3af'}
          >
            ×
          </button>
        </div>
        
        <div style={{ padding: '20px' }}>
          <CargaMasivaGenerico 
            config={{
              ...config,
              hideHeader: true,
              onDataLoaded: () => {
                if (onDataLoaded) onDataLoaded();
                onClose();
              }
            }} 
          />
        </div>
      </div>
    </div>
  );
};

export default ModalCargaMasiva;
